import { TaskObject } from './task-object.model';

export class TaskListObject {

  constructor(private page: number, private total: number, private elements: Array<TaskObject>) {

  }

  public static create(): TaskListObject {
    return new TaskListObject(null, null, new Array<TaskObject>());
  }

  public getPage(): number {
    return this.page;
  }

  public getTotal(): number {
    return this.total;
  }

  public getElements(): Array<TaskObject> {
    return this.elements;
  }

  public setPage(page: number): void {
    this.page = page;
  }

  public setTotal(total: number): void {
    this.total = total;
  }

  public setElements(elements: Array<TaskObject>): void {
    this.elements = elements;
  }
}
